import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components/macro'
import { t } from 'ttag'
import PropTypes from 'prop-types'

import { Get } from 'api/index'
import { bindActionCreators } from 'redux'
import {
  applyDocumentSearch,
  applyHeatMapSearch,
  applySearch,
  saveDocumentSearch,
  saveSearch
} from 'store/actions/search'
import { show } from 'redux-modal'
import breakpoints from 'assets/stylesheet'
import {
  filtersList,
  regionsList,
  setCurrentSearchable,
  updateSelectedFilters
} from 'store/actions/filters'
import { initialState as initialFilters } from 'store/reducers/filters'
import SearchableMultiSelectHigherLevel from 'components/filters/SearchableMultiSelectHigherLevel'
import SearchFilterButton from 'components/ui/SearchFilterButton'
import SearchableMultiSelect from 'components/filters/SearchableMultiSelect'
import ProjectLanguages from 'components/filters/ProjectLanguages'
import ProjectDetails from 'components/filters/ProjectDetails'
import MultiSelect from 'components/filters/MultiSelect'
import ProgrammeRelatedMultiSelectPeriod from 'components/filters/ProgrammeRelatedMultiSelectPeriod'
import ProgrammeRelatedMultiSelectType from 'components/filters/ProgrammeRelatedMultiSelectType'
import MultiSelectFields from 'components/filters/MultiSelectFields'
import MultiSelectPartnerType from 'components/filters/MultiSelectPartnerType'
import CARNutsSelector from 'components/filters/CARNutsSelector'
import MultiNutsSelector from 'components/filters/MultiNutsSelector'
import Investments from 'components/filters/Investments'
import Button from 'components/ui/Button'
import SearchableMultiSelectTree from 'components/filters/SearchableMultiSelectTree'
import DocumentTypes from 'components/filters/DocumentTypes'
import Themes from 'components/filters/Themes'
import FreeTextSearch from 'components/filters/FreeTextSearch'
import ProjectBudget from 'components/filters/ProjectBudget'
import ConditionalFreeTextSearch from 'components/filters/ConditionalFreeTextSearch'
import FilterSection from 'components/ui/FilterSection'
import {
  INCLUDED_VALUE,
  PermissionStatusStates,
  SearchableOptions
} from 'store/constants/constants'
import ArrayMultiSelectHigherLevel from 'components/filters/ArrayMultiSelectHigherLevel'
import DocumentLanguages from 'components/filters/DocumentLanguages'
import pako from 'pako'
import ProgrammeHierarchyMultiSelect from 'components/filters/ProgrammeHierarchyMultiSelect'
import NutsSelector from 'components/filters/NutsSelector'
import MacroRegionalStrategiesMultiSelect from 'components/filters/MacroRegionalStrategiesMultiSelect'

const SearchContainer = styled.div`
  width: 430px;
  transition: all 0.4s ease;
  position: relative;
  left: ${props => (props.isSidebarVisible ? '0' : '-430px')};
  @media (max-width: ${breakpoints.bpTabletPx}) {
    left: ${props => (props.isSidebarVisible ? '0' : '-100%')};
    width: 100%;
  }
`
const SearchHeader = styled.h1`
  margin: 0px 30px 0px 27px;
  color: #4a4a4a;
  padding-bottom: 6px;
  border-bottom: 3px solid #9faee5;
  font-size: 28px;
  @media (max-width: ${breakpoints.bpPhonePx}) {
    margin: 0 15px;
    padding: 15px 0 6px;
    font-size: 20px;
  }
`
const SearchFilters = styled.div`
  background-color: #eaeaee;
  padding: 20px 0;
  box-shadow: 5px 0 5px -2px rgba(136, 136, 136, 0.55);
  position: relative;
  top: 0;
  bottom: 0;
  min-height: 100vh;
  height: 100%;
  @media (max-width: ${breakpoints.bpPhonePx}) {
    padding: 0;
  }
`
const FilterSectionTitle = styled.h2`
  margin-top: ${props => (props.isDocumentSection ? '0' : '1.8rem')} !important;
  @media (max-width: ${breakpoints.bpPhonePx}) {
    font-size: 18px !important;
    margin-top: ${props => (props.isDocumentSection ? '0' : '1rem')} !important;
    margin-bottom: 4px !important;
  }
`
const ButtonWrapper = styled.div`
  position: relative;
`
const CriteriaInfoWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
`
const Loading = styled.div`
  padding: 20px 30px 20px 50px;
  @media (max-width: ${breakpoints.bpPhonePx}) {
    padding: 20px 15px;
  }
`
const CriteriaInfoIcon = styled.i`
  font-size: 16px;
  color: #9faee5;
  margin: 10px;
  cursor: pointer;
`
const FilterInfoIcon = styled.i`
  font-size: 16px;
  color: #9faee5;
  margin-right: 10px;
  cursor: pointer;
`
const ResultsButton = styled(Button)`
  position: fixed;
  left: 10px;
  bottom: 10px;
  width: 410px;
  @media (max-width: ${breakpoints.bpPhonePx}) {
    width: calc(100vw - 20px);
  }
  display: ${props => (props.isSidebarVisible ? 'block' : 'none')};
`

class SearchComponent extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      currentFilterId: ''
    }

    this.loadSavedFilters = this.loadSavedFilters.bind(this)
    this.locationError = this.locationError.bind(this)
    this.closeFilter = this.closeFilter.bind(this)
    this.handleSearchSubmit = this.handleSearchSubmit.bind(this)
    this.locationSuccess = this.locationSuccess.bind(this)
  }

  componentDidMount() {
    const {
      setCurrentSearchable: setCurrentSearchableAction,
      filtersList: filtersListAction,
      regionsList: regionsListAction,
      searchPage
    } = this.props
    const regionParams = {
      geometry: false
    }
    let filterParams = {
      list: true,
      with_published: 'project'
    }
    if (searchPage === SearchableOptions.PROGRAMMES) {
      filterParams = {
        list: true,
        with_published: 'programme'
      }
    }
    setCurrentSearchableAction(searchPage)
    regionsListAction(regionParams)
    const { hash } = window.location
    let useThemeFilter = false
    const urlParams = new URLSearchParams(window.location.search)
    const programmeId = urlParams.get('programme_id')
    if (hash.startsWith('#search:')) {
      this.loadSavedFilters(hash.substring(8))
    } else if (programmeId) {
      this.loadProgrammeSearch(programmeId)
    } else if (searchPage === SearchableOptions.PROJECTS) {
      if (hash.startsWith('#theme:')) {
        useThemeFilter = true
      } else {
        navigator.geolocation.getCurrentPosition(this.locationSuccess, this.locationError)
      }
    } else {
      this.applySearchFilters(searchPage, true)
    }
    filtersListAction(filterParams).then(() => {
      const { setCurrentFilters } = this.props
      setCurrentFilters(this.initFilters())
      if (useThemeFilter) {
        this.loadThemeFilter(hash.substring(7))
      }
    })
  }

  loadSavedFilters(filtersIdentifier) {
    const { updateSelectedFilters: updateSelectedFiltersAction, searchPage } = this.props
    try {
      const intitialSelectedFilters = initialFilters.selectedFilters
      const restored = JSON.parse(pako.inflate(atob(filtersIdentifier), { to: 'string' }))

      // In the case that, the schema of the search has changed since the hash
      // has been created, make sure the new filter fields exist in
      // the restored filter object.
      Object.keys(intitialSelectedFilters[searchPage]).forEach(key => {
        if (!restored[key]) {
          restored[key] = intitialSelectedFilters[searchPage][key]
        } else {
          Object.keys(intitialSelectedFilters[searchPage][key]).forEach(key2 => {
            if (!restored[key][key2]) {
              restored[key][key2] = intitialSelectedFilters[searchPage][key][key2]
            }
          })
        }
      })
      const data = {
        wholeFilterObject: restored
      }
      updateSelectedFiltersAction(data)
      // A dirty way of making the search filters to be applied
      // AFTER the above updateSelectedFiltersAction has been
      // applied to the redux state. setTimeout skips 1 update
      // iteration if no time has been applied to it. It might
      // be wise to change this to a more "appropriate"
      // solution in the future.
      setTimeout(() => this.handleSavedFilterResult(searchPage))
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e)
    }
  }

  async loadProgrammeSearch(programmeId) {
    const {
      updateSelectedFilters: updateSelectedFiltersAction,
      filters: {
        selectedFilters: {
          projects: { programmes }
        }
      },
      searchPage
    } = this.props
    try {
      // A dirty way of making the search filters to be applied
      // AFTER the above updateSelectedFiltersAction has been
      // applied to the redux state. setTimeout skips 1 update
      // iteration if no time has been applied to it. It might
      // be wise to change this to a more "appropriate"
      // solution in the future.
      const programme = await Get(`/api/programme/${programmeId}`)
      const data = {
        filterId: 'programmes',
        filterValue: {
          ...programmes,
          available: [{ id: programmeId, label: programme.title }]
        },
        isHigherLevelFilter: true
      }
      await updateSelectedFiltersAction(data)
      setTimeout(() => this.handleSavedFilterResult(searchPage))
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e)
    }
  }

  loadThemeFilter(themeId) {
    const {
      searchPage,
      filters: { availableFilters },
      updateSelectedFilters: updateSelectedFiltersAction
    } = this.props

    const selectedThemes = availableFilters.projects.themes.filter(
      theme => theme.id === parseInt(themeId, 10)
    )
    if (selectedThemes.length > 0) {
      const returnValue = {
        list: [{ id: selectedThemes[0].id, label: selectedThemes[0].title }],
        type: 'or'
      }
      const data = {
        filterType: SearchableOptions.PROJECTS,
        filterId: 'themes',
        filterValue: returnValue
      }
      updateSelectedFiltersAction(data)
      setTimeout(() => this.applySearchFilters(searchPage, true))
    } else {
      this.applySearchFilters(searchPage, true)
    }
  }

  handleSavedFilterResult(searchPage) {
    const {
      filters: { selectedFilters }
    } = this.props
    if (
      searchPage === SearchableOptions.PROJECTS &&
      selectedFilters[SearchableOptions.PROJECTS].location != null
    ) {
      this.handleLocationForSavedSearch()
    } else {
      this.applySearchFilters(searchPage, true)
    }
  }

  locationSuccess(position) {
    const { searchPage, updateSelectedFilters: updateSelectedFiltersAction } = this.props
    const filterValue = {
      lng: position.coords.longitude,
      lat: position.coords.latitude
    }
    const data = {
      filterId: 'location',
      filterValue,
      isHigherLevelFilter: true
    }
    updateSelectedFiltersAction(data)
    setTimeout(() => this.applySearchFilters(searchPage, true))
  }

  locationError() {
    const { searchPage, updateSelectedFilters: updateSelectedFiltersAction } = this.props
    const data = {
      filterId: 'location',
      filterValue: null,
      isHigherLevelFilter: true
    }
    updateSelectedFiltersAction(data)
    setTimeout(() => this.applySearchFilters(searchPage, true))
  }

  initFilters() {
    const {
      filters: { availableFilters, regions, currentSearchable }
    } = this.props

    const filters = {
      projects: [
        {
          name: 'Text search',
          info: 'text-search-in-projects-and-documents-what-is-it-how-does-it-work',
          filters: [
            {
              componentType: ConditionalFreeTextSearch,
              unToggleable: true
            },
            {
              type: 'search',
              title: 'Fields to include in text search',
              info: 'text-search-in-projects-and-documents-what-fields-does-it-include',
              componentType: MultiSelectFields,
              values: ['fields'],
              data: availableFilters.search.fields
            },
            {
              type: 'languages',
              title: 'Languages to include in text search',
              info: 'languages-to-include-in-projects-and-documents-text-search-why-use-this-filter',
              componentType: ProjectLanguages,
              values: ['project_lang'],
              data: availableFilters.general.project_languages,
              customTop: '-85px'
            }
          ]
        },
        {
          name: 'Language criterion',
          info: 'language-criterion-in-projects-and-documents-how-different-is-it-from-the-language-criterion-in-text-search',
          filters: [
            {
              type: 'translation_languages',
              title: 'Search data in specific language(s) only',
              componentType: ProjectLanguages,
              values: ['project_desc_lang'],
              data: availableFilters.general.project_languages,
              customTop: '-85px',
              info: 'language-search-data-in-specific-languages-only-why-use-this-filter'
            }
          ]
        },
        {
          name: 'Funding criteria',
          info: 'funding-criteria-what-is-including-in-projects-and-documents-funding-criteria',
          filters: [
            {
              type: 'programmes',
              title: 'Types of programme',
              componentType: ProgrammeRelatedMultiSelectType,
              values: ['type'],
              data: availableFilters.programmes.type,
              keyWord: 'title',
              info: 'type-of-programme-what-is-it'
            },
            {
              type: 'programmes',
              title: 'Programming periods',
              componentType: ProgrammeRelatedMultiSelectPeriod,
              values: ['period'],
              data: availableFilters.programmes.period,
              keyWord: 'title',
              info: 'programming-period-what-is-it'
            },
            {
              type: 'programmes',
              title: 'Programmes',
              componentType: ProgrammeHierarchyMultiSelect,
              values: ['available'],
              keyWord: 'title',
              info: 'programmes-what-does-it-mean-within-the-scope-of-keep'
            }
          ]
        },
        {
          name: 'Project times and budget criteria',
          info: 'project-times-and-budget-criteria-what-filters-are-included',
          filters: [
            {
              type: 'projects',
              title: 'Project times criteria',
              componentType: ProjectDetails,
              values: [
                'status',
                'only_projects_with_documents',
                'project_details.start',
                'project_details.without_start',
                'project_details.end',
                'project_details.without_end'
              ],
              data: availableFilters.projects,
              info: 'project-times-criteria-what-filters-are-included'
            },
            {
              type: 'projects',
              title: 'Project budget criteria',
              componentType: ProjectBudget,
              values: ['project_budget.range', 'project_budget.without_budget'],
              data: availableFilters.projects,
              info: 'project-budget-criteria-what-filters-are-included'
            }
          ]
        },
        {
          name: 'Thematic criteria',
          info: 'thematic-criteria-in-keep-eu-why-so-many',
          filters: [
            {
              type: 'projects',
              title: 'Themes',
              componentType: Themes,
              values: ['themes'],
              data: availableFilters.projects.themes,
              keyWord: 'title',
              info: 'thematics-what-are-they-how-are-they-assigned-to-projects'
            },
            {
              type: 'projects',
              title: 'Macro-regional strategies',
              componentType: MacroRegionalStrategiesMultiSelect,
              values: ['macro_regional_strategies'],
              data: [
                { id: INCLUDED_VALUE, label: 'Included' },
                { id: 'eusbsr', label: 'Only EUSBSR projects' },
                { id: 'eusdr', label: 'Only EUSDR projects' },
                { id: 'eusalp', label: 'Only EUSALP projects' }
              ],
              keyWord: 'label',
              info: 'macro-regional-strategies-what-are-they'
            },
            {
              type: 'specific_objectives',
              title: 'Thematic Objectives - Investment Priorities',
              subTitle: '(2014-2020 Interreg projects only)',
              info: 'thematic-objectives-what-are-they-what-is-their-use',
              componentType: SearchableMultiSelectTree,
              values: ['thematic_objectives'],
              data: availableFilters.specific_objectives.thematic_objectives,
              keyWord: 'content'
            },
            {
              type: 'thematic_objectives_eni',
              title: 'Thematic Objectives',
              subTitle: '(2014-2020 ENI CBC programmes only)',
              componentType: SearchableMultiSelectHigherLevel,
              values: ['thematic_objectives_eni'],
              data: availableFilters.thematic_objectives_eni,
              keyWord: 'content',
              info: 'thematic-objectives-eni-cbc-what-are-they'
            },
            {
              type: 'specific_objectives',
              title: 'Thematic Priorities',
              subTitle: '(2014-2020 Interreg-IPA CBC projects only)',
              componentType: SearchableMultiSelect,
              values: ['thematic_priorities'],
              data: availableFilters.specific_objectives.thematic_priorities,
              keyWord: 'content',
              customTop: '-119px',
              info: 'thematic-priorities-ipa-cbc-what-are-they'
            },
            {
              type: 'projects',
              title: 'Investments',
              subTitle: '(financed infrastructure)',
              componentType: Investments,
              values: ['investments'],
              info: 'investments-in-infrastructure-what-is-this-filter-why-use-it'
            }
          ]
        },
        {
          name: 'Partner criteria',
          info: 'partner-what-is-it',
          filters: [
            {
              type: 'partners',
              title: 'Public/private',
              componentType: MultiSelectPartnerType,
              values: ['status'],
              data: availableFilters.partners.status,
              customTop: '-123px',
              info: 'public-private-partners-what-concepts-are-at-play-here'
            },
            {
              type: 'partners',
              title: 'Countries/regions of partners',
              keyWord: 'name',
              componentType: MultiNutsSelector,
              values: ['nuts_lead', 'nuts_partner', 'nuts_search_type'],
              data: regions,
              customTop: '-440px',
              info: 'countries-and-regions-how-are-regions-defined-how-can-they-be-used-in-keep-eu-searches'
            }
          ]
        },
        {
          name: 'Documents',
          info: 'documents-what-is-a-document-for-keep-eu-how-can-an-exact-document-be-found-in-keep-eu',
          filters: [
            {
              type: 'documents',
              title: '',
              componentType: FreeTextSearch,
              values: ['name'],
              customTop: '-353px',
              unToggleable: true
            },
            {
              type: 'documents',
              title: 'Type',
              info: 'type-of-documents',
              componentType: DocumentTypes,
              values: ['types'],
              keyWord: 'name',
              data: availableFilters.projects.attachments.types,
              customTop: '-309px'
            },
            {
              type: 'documents',
              title: 'Language',
              componentType: DocumentLanguages,
              values: ['document_lang'],
              data: availableFilters.general.attachment_languages,
              info: 'language-search-for-documents-in-specific-languages-only-why-use-this-filter'
            }
          ]
        }
      ],
      programmes: [
        {
          name: 'Text search',
          filters: [
            {
              componentType: ConditionalFreeTextSearch,
              unToggleable: true
            }
          ]
        },
        {
          name: 'Basic criteria',
          info: 'basic-criteria-in-keep-eu-searches-what-is-relevant-about-this-set-of-filters',
          filters: [
            {
              type: 'programmes',
              title: 'Types of programme',
              componentType: ProgrammeRelatedMultiSelectType,
              values: ['type'],
              data: availableFilters.programmes.type,
              keyWord: 'title',
              info: 'type-of-programme-what-is-it'
            },
            {
              type: 'programmes',
              title: 'Programming periods',
              componentType: ProgrammeRelatedMultiSelectPeriod,
              values: ['period'],
              data: availableFilters.programmes.period,
              keyWord: 'title',
              info: 'programming-period-what-is-it'
            },
            {
              type: 'programmes',
              title: 'Countries/regions',
              keyWord: 'name',
              componentType: NutsSelector,
              values: ['nuts'],
              data: regions,
              customTop: '-189px',
              info: 'countries-and-regions-how-are-regions-defined-how-can-they-be-used-in-keep-eu-searches'
            }
          ]
        },
        {
          name: 'Thematic criteria',
          info: 'thematic-criteria-in-keep-eu-why-so-many',
          filters: [
            {
              type: 'specific_objectives',
              title: 'Thematic Objectives - Investment Priorities',
              subTitle: '(2014-2020 Interreg programmes only)',
              info: 'thematic-objectives-what-are-they-what-is-their-use',
              componentType: SearchableMultiSelectTree,
              values: ['thematic_objectives'],
              data: availableFilters.specific_objectives.thematic_objectives,
              keyWord: 'content',
              customTop: '-150px'
            },
            {
              type: 'thematic_objectives_eni',
              title: 'Thematic Objectives',
              subTitle: '(2014-2020 ENI CBC programmes only)',
              componentType: SearchableMultiSelectHigherLevel,
              values: ['thematic_objectives_eni'],
              data: availableFilters.thematic_objectives_eni,
              keyWord: 'content',
              customTop: '-58px',
              info: 'thematic-objectives-eni-cbc-what-are-they'
            },
            {
              type: 'specific_objectives',
              title: 'Thematic Priorities',
              subTitle: '(2014-2020 Interreg-IPA CBC programmes only)',
              componentType: SearchableMultiSelect,
              values: ['thematic_priorities'],
              data: availableFilters.specific_objectives.thematic_priorities,
              keyWord: 'content',
              customTop: '-119px',
              info: 'thematic-priorities-ipa-cbc-what-are-they'
            },
            {
              type: 'specific_objectives',
              title: 'Common output indicators',
              subTitle: '(2014-2020 Interreg and Interreg-IPA CBC programmes only)',
              componentType: MultiSelect,
              values: ['common_output_indicators'],
              data: availableFilters.common_output_indicators,
              customTop: '-173px',
              info: 'common-output-indicators-2014-2020-interreg-what-are-they'
            },
            {
              type: 'thematic_objectives_eni_common_output_indicators',
              title: 'Common output indicators',
              subTitle: '(2014-2020 ENI CBC programmes only)',
              componentType: ArrayMultiSelectHigherLevel,
              values: ['thematic_objectives_eni_common_output_indicators'],
              data: availableFilters.common_output_indicators_eni,
              keyWord: 'content',
              customTop: '-238px',
              info: 'common-output-indicators-2014-2020-eni-cbc-what-are-they'
            }
          ]
        }
      ],
      partners: [
        {
          name: 'Text search',
          filters: [
            {
              componentType: ConditionalFreeTextSearch,
              unToggleable: true
            }
          ]
        },
        {
          name: 'Basic criteria',
          info: 'basic-criteria-in-keep-eu-searches-what-is-relevant-about-this-set-of-filters',
          filters: [
            {
              type: 'partners',
              title: 'Public/private',
              componentType: MultiSelect,
              values: ['status'],
              data: availableFilters.partners.status,
              info: 'public-private-partners-what-concepts-are-at-play-here'
            },
            {
              type: 'partners',
              title: 'Countries/regions',
              keyWord: 'name',
              componentType: NutsSelector,
              values: ['nuts'],
              data: regions,
              customTop: '-189px',
              info: 'countries-and-regions-how-are-regions-defined-how-can-they-be-used-in-keep-eu-searches'
            }
          ]
        },
        {
          name: 'Experience',
          info: 'past-experience-criteria-in-keep-eu-searches-how-to-use-this-set-of-filters',
          filters: [
            {
              type: 'partners',
              title: 'Lead partner or project partner',
              componentType: MultiSelect,
              values: ['type'],
              data: availableFilters.partners.type.filter(type => type !== 'associate'),
              info: 'partner-what-is-it'
            },
            {
              type: 'projects',
              title: 'Experience (per keep.eu themes)',
              info: 'thematics-what-are-they-how-are-they-assigned-to-projects',
              componentType: Themes,
              values: ['themes'],
              data: availableFilters.projects.themes,
              keyWord: 'title',
              customTop: '-80px'
            },
            {
              type: 'programmes',
              title: 'Programming periods',
              componentType: ProgrammeRelatedMultiSelectPeriod,
              values: ['period'],
              data: availableFilters.programmes.period,
              keyWord: 'title',
              info: 'programming-period-what-is-it'
            },
            {
              type: 'programmes',
              title: 'Types of programme',
              info: 'type-of-programme-what-is-it',
              componentType: ProgrammeRelatedMultiSelectType,
              values: ['type'],
              data: availableFilters.programmes.type,
              keyWord: 'title'
            },
            {
              type: 'programmes',
              title: 'Programmes',
              info: 'programmes-what-does-it-mean-within-the-scope-of-keep',
              componentType: ProgrammeHierarchyMultiSelect,
              values: ['available'],
              data: availableFilters.programmes.available,
              keyWord: 'title'
            },
            {
              type: 'specific_objectives',
              title: 'Experience per Thematic Objective/Investment Priority',
              subTitle: '(2014-2020 Interreg only)',
              info: 'thematic-objectives-what-are-they-what-is-their-use',
              componentType: SearchableMultiSelectTree,
              values: ['thematic_objectives'],
              data: availableFilters.specific_objectives.thematic_objectives,
              keyWord: 'content'
            },
            {
              type: 'thematic_objectives_eni',
              title: 'Experience per Thematic Objective',
              subTitle: '(2014-20 ENI CBC only)',
              componentType: SearchableMultiSelectHigherLevel,
              values: ['thematic_objectives_eni'],
              data: availableFilters.thematic_objectives_eni,
              keyWord: 'content',
              customTop: '-100px',
              info: 'thematic-objectives-eni-cbc-what-are-they'
            },
            {
              type: 'specific_objectives',
              title: 'Experience per Thematic Priority',
              subTitle: '(2014-20 Interreg-IPA cross-border only)',
              componentType: SearchableMultiSelect,
              values: ['thematic_priorities'],
              data: availableFilters.specific_objectives.thematic_priorities,
              keyWord: 'content',
              customTop: '-153px',
              info: 'thematic-priorities-ipa-cbc-what-are-they'
            }
          ]
        }
      ],
      countries_and_regions: [
        {
          name: 'Text search',
          filters: [
            {
              componentType: ConditionalFreeTextSearch,
              unToggleable: true
            }
          ]
        },
        {
          name: 'Select geographic scope',
          info: 'countries-and-regions-how-are-regions-defined-how-can-they-be-used-in-keep-eu-searches',
          filters: [
            {
              keyWord: 'name',
              componentType: CARNutsSelector,
              values: [],
              data: [],
              customTop: '-276px',
              unToggleable: true
            }
          ]
        }
      ]
    }
    return filters[currentSearchable]
  }

  async handleSearchSubmit() {
    const {
      filters: { currentSearchable, selectedFilters },
      updateSelectedFilters: updateSelectedFiltersAction
    } = this.props
    if (selectedFilters && selectedFilters.projects && selectedFilters.projects.location) {
      const data = {
        filterId: 'location',
        filterValue: null,
        isHigherLevelFilter: true
      }
      await updateSelectedFiltersAction(data)
    }
    this.applySearchFilters(currentSearchable, false, null)
  }

  handleLocationForSavedSearch() {
    navigator.permissions.query({ name: 'geolocation' }).then(permissionStatus => {
      if (permissionStatus.state === PermissionStatusStates.DENIED) {
        this.handleSavedSearchLocationError()
      } else if (permissionStatus.state === PermissionStatusStates.GRANTED) {
        navigator.geolocation.getCurrentPosition(this.handleSavedSearchLocationSuccess)
      } else if (permissionStatus.state === PermissionStatusStates.PROMPT) {
        navigator.geolocation.getCurrentPosition(
          this.handleSavedSearchLocationSuccess,
          this.handleSavedSearchLocationError
        )
      }
    })
  }

  handleSavedSearchLocationSuccess(position) {
    const {
      updateSelectedFilters: updateSelectedFiltersAction,
      onLocationPermissionResult,
      searchPage
    } = this.props
    const filterValue = {
      lng: position.coords.longitude,
      lat: position.coords.latitude
    }
    const data = {
      filterId: 'location',
      filterValue,
      isHigherLevelFilter: true
    }
    updateSelectedFiltersAction(data)
    onLocationPermissionResult(true)
    setTimeout(() => this.applySearchFilters(searchPage, true))
  }

  handleSavedSearchLocationError() {
    const { show: showAction, onLocationPermissionResult } = this.props
    onLocationPermissionResult(false)
    showAction('infoModal', {
      title: t`Location criterion`,
      message: t`In order to search nearby projects, you need to enable location permission in your browser's settings. 
      This search will be done without the location filter`
    })
    this.locationError()
  }

  applySearchFilters(searchable, initial = false) {
    const {
      filters: { selectedFilters },
      applySearch: applySearchAction,
      applyDocumentSearch: applyDocumentSearchAction,
      applyHeatMapSearch: applyHeatMapSearchAction,
      saveSearch: saveSearchAction,
      saveDocumentSearch: saveDocumentSearchAction,
      onToggleSideBar,
      onLocationPermissionResult
    } = this.props
    const data = {
      currentSearchable: searchable,
      body: selectedFilters[searchable]
    }

    if (selectedFilters[SearchableOptions.PROJECTS].location != null) {
      onLocationPermissionResult(true)
    } else {
      onLocationPermissionResult(false)
    }

    applySearchAction(data).then(response => {
      saveSearchAction(selectedFilters[searchable])
      if (searchable === SearchableOptions.PROJECTS) {
        const foundProjectIds = response.value ? response.value.project_ids : []
        if (foundProjectIds.length > 0) {
          applyHeatMapSearchAction({
            body: {
              ...selectedFilters[searchable],
              all_partnerships: true
            }
          })

          const selectedLanguages = selectedFilters[
            SearchableOptions.PROJECTS
          ].documents.document_lang.map(language => language.id)
          const selectedTypes = selectedFilters[SearchableOptions.PROJECTS].documents.types

          const freeTextSearch = selectedFilters[SearchableOptions.PROJECTS].documents.name
          const documentData = {
            body: {
              documents: {
                projects: foundProjectIds,
                ...(selectedLanguages.length > 0 && {
                  languages: selectedLanguages
                }),
                ...(selectedTypes.length > 0 && {
                  types: selectedTypes
                }),
                ...(freeTextSearch &&
                  freeTextSearch.length > 0 && {
                    name: freeTextSearch
                  })
              }
            }
          }
          applyDocumentSearchAction(documentData).then(() => {
            saveDocumentSearchAction(documentData)
          })
        }
      }
    })
    if (!initial) {
      this.setState({
        currentFilterId: ''
      })
      onToggleSideBar()
    }
  }

  async onCriteriaInfoClick(title, message) {
    const { show: showAction } = this.props
    const data = await fetch(`/wp-json/wp/v2/pages?slug=${message}`)
    const jsonData = await data.json()
    const msg = jsonData[0].content.rendered
    showAction('infoModal', { message: msg })
  }

  handleFilterButtonClick(filterId) {
    const { currentFilterId } = this.state
    if (filterId === currentFilterId) {
      this.setState({
        currentFilterId: ''
      })
    } else {
      this.setState({
        currentFilterId: filterId
      })
    }
  }

  renderHeader() {
    const { searchPage } = this.props
    switch (searchPage) {
      case SearchableOptions.PROJECTS:
        return t`Projects and documents`
      case SearchableOptions.PROGRAMMES:
        return t`Programmes`
      case SearchableOptions.PARTNERS:
        return t`Partners`
      case SearchableOptions.COUNTRIES_AND_REGIONS:
        return t`Countries and regions`
      default:
        return null
    }
  }

  closeFilter() {
    this.setState({
      currentFilterId: ''
    })
  }

  render() {
    const {
      filters: { isPending, submitEnabled },
      isSidebarVisible,
      currentFilters
    } = this.props
    const { currentFilterId } = this.state
    const filtersPending = isPending

    const filters = (
      <>
        {currentFilters.map((item, index) => (
          <FilterSection
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            isDocumentSection={item.name === 'Documents'}
          >
            {item.name ? (
              <FilterSectionTitle isDocumentSection={item.name === 'Documents'}>
                {item.name}{' '}
                {item.info && (
                  <CriteriaInfoIcon
                    onClick={() => this.onCriteriaInfoClick(item.name, item.info)}
                    className="far fa-question-circle"
                  />
                )}
              </FilterSectionTitle>
            ) : null}
            {item.filters.map((filter, idx) => {
              const FilterComponent = filter.componentType
              return (
                // eslint-disable-next-line react/no-array-index-key
                <div key={`${item.name}_${idx}`}>
                  {filter.unToggleable ? (
                    <FilterComponent
                      type={filter.type}
                      filterData={filter.data}
                      values={filter.values}
                      title={filter.title}
                      info={filter.info}
                      keyWord={filter.keyWord ? filter.keyWord : null}
                      customTop={filter.customTop ? filter.customTop : null}
                      onClose={this.closeFilter}
                      showFilter={`${item.name}_${idx}` === currentFilterId}
                      applySearch={this.handleSearchSubmit}
                      submitEnabled={submitEnabled}
                    />
                  ) : (
                    <ButtonWrapper
                      // eslint-disable-next-line react/no-array-index-key
                      key={`${item.name}_${idx}`}
                    >
                      <CriteriaInfoWrapper>
                        <FilterInfoIcon
                          onClick={() => this.onCriteriaInfoClick(filter.title, filter.info)}
                          className="far fa-question-circle"
                        />
                        <SearchFilterButton
                          background={item.name === 'Documents' ? '#d9d9e0' : '#eaeaee'}
                          active={`${item.name}_${idx}` === currentFilterId}
                          name={filter.title}
                          subTitle={filter.subTitle}
                          onClick={() => this.handleFilterButtonClick(`${item.name}_${idx}`)}
                        />
                      </CriteriaInfoWrapper>
                      <FilterComponent
                        type={filter.type}
                        filterData={filter.data}
                        values={filter.values}
                        title={filter.title}
                        info={filter.info}
                        keyWord={filter.keyWord ? filter.keyWord : null}
                        customTop={filter.customTop ? filter.customTop : null}
                        onClose={this.closeFilter}
                        showFilter={`${item.name}_${idx}` === currentFilterId}
                      />
                    </ButtonWrapper>
                  )}
                </div>
              )
            })}
          </FilterSection>
        ))}
        <FilterSection>
          <ResultsButton
            size="large"
            disabled={!submitEnabled}
            isSidebarVisible={isSidebarVisible}
            onClick={this.handleSearchSubmit}
          >
            {t`Show results`}
          </ResultsButton>
        </FilterSection>
      </>
    )

    return (
      <SearchContainer isSidebarVisible={isSidebarVisible}>
        <SearchFilters>
          <SearchHeader>{this.renderHeader()}</SearchHeader>
          {filtersPending ? <Loading>{t`Loading filters ...`}</Loading> : filters}
        </SearchFilters>
      </SearchContainer>
    )
  }
}

SearchComponent.propTypes = {
  filtersList: PropTypes.func,
  regionsList: PropTypes.func,
  setCurrentSearchable: PropTypes.func,
  applySearch: PropTypes.func,
  applyDocumentSearch: PropTypes.func,
  applyHeatMapSearch: PropTypes.func,
  saveSearch: PropTypes.func,
  saveDocumentSearch: PropTypes.func,
  searchPage: PropTypes.string,
  show: PropTypes.func,
  filters: PropTypes.shape({
    availableFilters: PropTypes.any,
    regionsList: PropTypes.array,
    currentSearchable: PropTypes.string,
    selectedFilters: PropTypes.object,
    isPending: PropTypes.bool,
    submitEnabled: PropTypes.bool,
    regions: PropTypes.array
  }),
  isSidebarVisible: PropTypes.bool,
  onToggleSideBar: PropTypes.func,
  onLocationPermissionResult: PropTypes.func,
  setCurrentFilters: PropTypes.func,
  currentFilters: PropTypes.array,
  updateSelectedFilters: PropTypes.func
}

const mapStateToProps = ({ filters }) => ({
  filters
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      filtersList,
      setCurrentSearchable,
      applySearch,
      applyDocumentSearch,
      applyHeatMapSearch,
      show,
      regionsList,
      updateSelectedFilters,
      saveSearch,
      saveDocumentSearch
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(SearchComponent)
